import { CustomerAccountToastProps } from '../types';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
export const CustomerAccountToast = ({
  children,
  classname,
  ...toastProps
}: CustomerAccountToastProps) => {
  return (
    <CatToastGroup verticalPosition={'top'} horizontalPosition={'center'}>
      <CatToast
        {...toastProps}
        autoClose={true}
        dismissible={true}
        className={classname}
      >
        {children}
      </CatToast>
    </CatToastGroup>
  );
};
